import React, { HTMLAttributes, ReactNode, Ref } from 'react';

import { Link } from '@sbu/components.link';

export interface ClickLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean;
  ref?: Ref<HTMLAnchorElement>;
  children?: ReactNode;
}

export const ClickLink = React.forwardRef<HTMLAnchorElement, ClickLinkProps>(
  ({ onClick, ...rest }, ref) => {
    const onLinkClick = (
      event: React.MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
    ) => {
      event.preventDefault();
      event.stopPropagation();

      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Link
        variant='a'
        display='inline'
        fontSize='inherit'
        fontWeight='inherit'
        href='#'
        onClick={onLinkClick}
        {...rest}
        ref={ref}
      />
    );
  }
);
